import { styled } from "@mui/styles";
import Modal from "@mui/material/Modal";

export const StyledModal = styled(Modal)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& ::-webkit-scrollbar': {
        width: '5px'
    },
    
    '& ::-webkit-scrollbar-thumb': {
        borderRadius: '20px',
        border: '1px solid #00884c',
        backgroundColor: '#00884c'
    },
    
    '& ::-webkit-scrollbar-track': {
        backgroundColor: '#f5f5f5',
        margin: '10px 0',
        borderRadius: '20px',
        border: '1px solid #f5f5f5'
    },

    '& .InsideContainer': {
        padding: '30px 35px',
        minWidth: '500px',
        maxWidth: '45%',
        backgroundColor: 'white',
        maxHeight: 'inherit',
        borderRadius: '10px',

        // [theme.breakpoints.down('lg')]: {
        //     minWidth: '600px'
        // },

        [theme.breakpoints.down('md')]: {
            minWidth: '450px'
        },
        
        [theme.breakpoints.down('sm')]: {
            minWidth: '370px',
            padding: '0'
        },
    },

    '& .Header': {
        position: 'relative', borderBottom: `1px solid ${theme.palette.neutral.light}`, padding: '10px',

        '& .MuiTypography-root': {
            fontSize: '28px',
            fontWeight: 600,
            [theme.breakpoints.down('sm')]: {
                fontSize: '20px'
            }
        },

        '& .CrossButton': {
            color: 'black', position: 'absolute', top: '-18px', right: '-36px',
            fontSize: '20px',

            [theme.breakpoints.down('sm')]: {
                top: '0px',
                right: '-10px',
                fontSize: 'unset'
            }
        }
    },

    '& .Body': {
        maxHeight: '70vh', overflowY: 'auto', padding: '10px',
        padding: '20px',
    },

    '& .Footer': {
        padding: '10px',
        borderTop: `1px solid ${theme.palette.neutral.light}`,
        justifyContent: 'space-between',
        flexDirection: 'row'
    }
}))